import { SectionDataById } from '@src/app-components/dynamic-form/types';
import { permitProcessGuideQuestions } from './permitProcessGuideData.questions';

export const sectionsById: SectionDataById = {
  1: {
    formId: 1,
    sectionName: 'Questionnaire',
    questions: permitProcessGuideQuestions,
  },
};
